import Image from "components/Image"
import styled from "@emotion/styled"
import { css } from "@emotion/react"

const HeroScrollBackgroundImage = styled(Image)`
  height: 85dvh;
  width: 100dvw;
  display: block;
  position: relative;
`

export default HeroScrollBackgroundImage
